'use strict';

angular.module('atex.dam').controller('DamCollectionController', ['$scope', '$http', '$rootScope', '$state', '$stateParams', '$modal', '$q', 'CollectionService', 'ContentService', 'DamTemplateService', '$window','ArtConfirmModal','$translate','DamService','AuthenticationService','DamNotificationService','DrawerService','$timeout',
  'DamActivityService', 'PublishService', 'SearchService', 'valdr', 'valdrUtil', 'valdrEvents', 'configuration',
function($scope, $http, $rootScope, $state, $stateParams, $modal, $q, CollectionService, ContentService, DamTemplateService, $window, ArtConfirmModal, $translate, DamService, AuthenticationService,DamNotificationService, DrawerService, $timeout, DamActivityService, PublishService, SearchService, valdrProvider, valdrUtil, valdrEvents, configuration) {
  $scope.toSave   = false;
  $scope.saving   = false;
  $scope.aligned  = true;
  $scope.entries  = [];
  $scope.toggle='col-lg-7';
  $scope.confirmModal = {};
  $scope.confirmModal.show=false;
  $scope.viewsStateArray = [];
  $scope.valdError = false;

  $scope.id = $stateParams.id;

  $scope.readonly = $stateParams.preview === "preview";

  $scope.collection = {};
  $scope.template = undefined;

  $scope.showSpinner = true;
  $scope.loaded = false;

  $scope.intervalq={};

  CollectionService.clearSelection();
  $scope.selected = CollectionService.getSelected();

  var hasDeskGalleryWidget = false;

  var isEditingChilds = false;

  var setDirty = function(bVal) {
    $scope.toSave = bVal;
    CollectionService.setDirty($scope.toSave);
  };
  setDirty(false);

  function checklock(collectionId) {
    if ($scope.readonly) {
      return $q.when();
    }
    var skipContents = !hasDeskGalleryWidget;
    return DamActivityService.lockCollection(collectionId, skipContents);
  }

  function evalGalleryId() {
    var engList = atex.onecms.ObjectUtils.accessor($scope.collection, 'data/aspects/engagementAspect/data/engagementList').value;
    if (engList && engList.length>0) {
      var eng = _.find(engList, function (_eng) {
        return _eng.appType === "atex.dm.polopoly";
      });
      if (eng) {
        $scope.galleryId = atex.dam.AngularUtils.removePolicyPrefix(eng.appPk);
        return;
      }
    }
    $scope.galleryId = undefined;
  }

  var getCookie = function(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) {
      return parts.pop().split(";").shift();
    }
    return undefined;
  };

  var setCookie = function(name, value) {
    document.cookie = name + '=' + value + ';path=/';
  };

  var setCookieIfNotAlreadySet = function(name, value) {
    if (typeof getCookie(name) === 'undefined') {
      setCookie(name, value);
    }
  };

  var addHasErrorFn = function(collection) {
    if (!collection.hasErrors) {
      collection.hasErrors = function (view) {
        return atex.dam.ViewUtils.viewHasError(view, $scope.viewsStateArray, $scope.template);
      };
    }
  };

  var updateScopeCollection = function(collection) {
    $scope.collection = collection;
    addHasErrorFn($scope.collection);
  };

  CollectionService.getCollection($scope.id).then(function(collection) {
    updateScopeCollection(collection);
    if ($scope.readonly) {
      return DamTemplateService.getTemplateById("atex.dam.standard.Collection.readonly");
    } else {
      return DamTemplateService.getFilteredTemplateFor($scope.collection).then(function(template) {
        if (!template) {
          // The old default template
          return DamTemplateService.getTemplateById("atex.dam.standard.Collection");
        }
        // HACK to use the the desk template with the pGallery widget, to be able to edit image descriptions.
        // i.e. if atex.dam.standard.Collection.act.messven is the template for the "create-new" menù
        // then we use atex.dam.standard.Collection.messven in desk collection-controller
        // we simply remove the ".act" from the id to calculate the corresponding desk template [max]
        if (template.id.indexOf(".act")) {
          var toLoad = template.id.replace(".act", "");
          return DamTemplateService.getTemplateById(toLoad);
        }
        return template;
      });
    }
  }).then(function(template) {
    if (!template) {
      console.log("Undefined template");
      return $q.reject("Undefined template");
    }
    template.dataBindings.forEach(function(binding) {
      if (binding.widget === "pGallery") {
        hasDeskGalleryWidget = true;
      }
    });
    $scope.template = angular.copy(template);
    valdrProvider.setValidation($scope.template);
    return checklock($scope.id);
  }).then(function(){
    $rootScope.currentEditingCollection = $scope.collection;
    evalGalleryId($scope.collection);
    if (!DrawerService.isCurrentCollection($scope.collection)) {
      $rootScope.$broadcast("dam:collectionRetrieved", $scope.collection);
    }
    $scope.loaded = true;
    if (!$scope.readonly) {
      watch4NewCollectionLinks();
    }
  }).then(null, function(error) {
    $scope.showSpinner = false;
    if (error.objectLocked) {
      // If the collection is locked, let's show the readonly view
      $state.go('list.collection', { 'id' : $scope.id, 'preview': 'preview' });
    } else if (error.childsLocked && error.allChildsIDs) {
      // If there are locked children, let's open the locked items view
      DamActivityService.getLockedItems(error.allChildsIDs).then(function(lockedItems) {
        if (lockedItems && lockedItems.length>0) {
          lockedItems.forEach(function(lockedItem) {
            atex.dam.AngularUtils.fixUrls(lockedItem.data);
            lockedItem._data = lockedItem.data;
          });
          // If some child item is locked, let's show locked items view
          $state.go('list.lockeditems', { collectionId: $scope.id, items : lockedItems });
        }
      });
    }
    if (!error.notified) {
      // If the error has not been notified, try to notify
      var errMsg = atex.onecms.ObjectUtils.getByPath(error || {}, 'data/message');
      if (errMsg===undefined) {
        errMsg = atex.onecms.ObjectUtils.getByPath(error || {}, 'cause');
      }
      var message = $translate.getTranslationTable().__ERROR_DURING_COLLECTION_RETRIEVE__ + " (" + errMsg +")";
      DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
    }
  });

  $scope.downLock=true;
  $scope.upLock=true;

  $rootScope.$broadcast('dam:hide-menu');

  $scope.$on('keydown', function(msg, code, event) {
    if ( code === 68 && event.shiftKey ) {
      if(!$scope.readonly && !$scope.downLock) {
        $rootScope.$broadcast("dam:collectionEntryMoveDown");
      }
    } else if ( code === 85 && event.shiftKey ) {
      if(!$scope.readonly && !$scope.upLock) {
        $rootScope.$broadcast("dam:collectionEntryMoveUp");
      }
    } else if ( code === 80 && event.shiftKey ) {
    	if($scope.galleryId) {
    	  $scope.preview($scope.galleryId);
    	} else {
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: $translate.getTranslationTable().__COLLECTION_NOT_EXPORTED__ }), true);
      }
    }
    $scope.$apply();
    event.stopPropagation();
  });

  $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
    if( $scope.toSave && (toState.name!==fromState.name || (toState.name===fromState.name && toParams.id !== fromParams.id)) ) {
      if(!$scope.confirmModal.show ) {
        $scope.confirmModal = $scope.create();
        $scope.confirmModal.show = true;

        $scope.confirmModal.then(function(confirmed) {
          if (confirmed) {
            setDirty(false);
            $scope.confirmModal.show = {};
            $scope.confirmModal.show = false;
            $scope.collection={};
            $scope.closepanel();
            $state.go(toState.name, toParams);
          }
          $scope.confirmModal.show = {};
          $scope.confirmModal.show = false;
        });
      }
      event.preventDefault();
    } else {
      var isReload = angular.equals(toState, fromState) && angular.equals(toParams, fromParams);
      $scope.collection={};
      $scope.closepanel();
      if (!isReload && !isEditingChilds) {
        // Unlock the editing collection
        var IDs = [$scope.id];
        if (hasDeskGalleryWidget) {
          $scope.entries.forEach(function (entry) {
            IDs.push(entry.id);
          });
        }
        DamActivityService.unlock(IDs);
      }
    }
  });

  $rootScope.$on('$stateChangeSuccess', function() {
    $rootScope.currentEditingCollection = undefined;
  });

  $scope.$on('dam:toggle', function(event) {
    $scope.toggle = ($scope.toggle === "col-lg-7") ? "list" : "col-lg-7";
  });

  $scope.$on('dam:reset-toggle', function(event) {
    $scope.toggle = "col-lg-7";
    $scope.$apply();
  });

  $scope.closepanel = function() {
    if( $scope.toggle === "list") {
      $scope.swipeme();
    }
  };

  $scope.swipeme = function() {
    if (DamService.isMobileDevice()) {
      $rootScope.$broadcast("dam:toggle");
    }
  };

  $scope.preview = function(id) {
    DamService.getGalleryUrl(id).then(function(result) {
      AuthenticationService.getCurrentUser().then(function(currentUser) {

        var userId = currentUser.principalId;
        var sessionKey = currentUser.token.replace(userId + '::', '');

        setCookie('polopoly.contentIdsInEdit', id);
        setCookieIfNotAlreadySet('sessionKey', sessionKey);
        setCookieIfNotAlreadySet('userId', userId);

        $window.open(result.data,"_blank");
      });
	  });
  };

  $scope.showAcePreview = function() {
    return configuration.getShowAcePreviewInDesk();
  };

  $scope.previewAce = function() {
    var aceUrl = configuration.getAcePreviewBaseUrl();
    if (aceUrl !== undefined){
      return AuthenticationService.callWithAuthentication(function (currentUser) {
        var url = "/onecms/dam/content/collectionpreview";
        var obj = {
          "contentId" : $scope.collection.id,
          "acePreviewVariant" : "webPreview",
          "acePreviewBaseUrl" : aceUrl
        };
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'warning', message: "Loading preview" }), true);
        $http({
          method: 'POST',
          url: url,
          data: obj,
          headers: {
            'Content-Type': 'text/plain',
            'X-Auth-Token': currentUser.token
          },
          timeout: 600000
        }).then(function (response) {
          $window.open(response.data, "_blank");
          return response;
        }).error(function(e){
          console.log(e);
        });
      });
    }
  };

  $scope.export = function() {
    if( $scope.toSave ) {
      $scope.confirmModal = $scope.create();
      $scope.confirmModal.show = true;

      $scope.confirmModal.then(function(confirmed) {
        if (confirmed) {
          $scope.confirmModal.show = {};
          $scope.confirmModal.show = false;
          $scope.publish();
        }
        $scope.confirmModal.show = {};
        $scope.confirmModal.show = false;
      });
    } else {
      $scope.publish();
    }
  };

  $scope.publish = function() {
    if (!$scope.collection || !$scope.collection.id) {
      return;
    }
    $scope.saving = true;
    PublishService.publish([$scope.collection]).then(function (exported) {
      return CollectionService.getCollection($scope.collection.id);
    }).then(function(collection) {
      $rootScope.$broadcast('dam:updatedItem', {'id': collection.id});
      DamNotificationService.addNotification(atex.dam.Notification({type: 'success', message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__}), false);
      updateScopeCollection(collection);
      $rootScope.currentEditingCollection = $scope.collection;
      evalGalleryId();
      $scope.aligned = true;
      $scope.saving = false;
    }).then(null, function (error) {
      DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: $translate.getTranslationTable().__ERROR_DURING_COLLECTION_EXPORT__ }), true);
      $scope.saving = false;
    });
  };

  $scope.create = function() {
    var confirmModal = ArtConfirmModal.create({
      'confirmHeader': $translate.getTranslationTable().__ARE_YOU_SURE__,
      'confirmBody':  $translate.getTranslationTable().__ARE_YOU_SURE__,
      'cancel':  $translate.getTranslationTable()._CANCEL_BUTTON_,
      'ok': 'Ok',
      'mode': 'primary'
    });

    return confirmModal;
  };

  $scope.$on("dam:collectionSave", function(event,update) {
    setDirty(update.save);
    $scope.entries=update.entries;
  });

  $scope.$on("dam:collectionCursorLock", function(event,lock) {
    $scope.downLock = lock.downLock;
    $scope.upLock = lock.upLock;
  });

  $scope.canEdit = function() {
    if ($scope.readonly) {
      return true;
    }
    if ($scope.selected.length <= 0) {
      return false;
    }
    var currentType;
    var bCanEdit = true;
    $scope.selected.forEach(function(selectedItem) {
      if (currentType !== undefined) {
        if (selectedItem._data.aspects.contentData.data._type !== currentType) {
          bCanEdit = false;
        }
      } else {
        currentType = selectedItem._data.aspects.contentData.data._type;
      }
    });
    return bCanEdit;
  };

  $scope.clearSelection = function() {
    CollectionService.clearSelection();
  };

  $scope.back = function() {
    $state.go('list');
  };

  $scope.up = function() {
    $rootScope.$broadcast("dam:collectionEntryMoveUp");
  };

  $scope.down = function() {
    $rootScope.$broadcast("dam:collectionEntryMoveDown");
  };

  var broadcastCropFromCollectionToImage = function(id, crop) {
    ContentService.getContent({id: id}).then(function (image) {
      if (crop.includes("Freeform")){
        if (image.data.aspects["atex.ImageEditInfo"] === undefined){
          image.data.aspects["atex.ImageEditInfo"] = {
            data: {
              _type: 'atex.ImageEditInfo',
              crops: {}
            }
          };
        }
        var collections = image.data.aspects["atex.collection"].data.collections;
        for (var i = 0; i < collections.length; i++){
          if (collections[i].contentId === $scope.collection.data.id){
            image.data.aspects["atex.ImageEditInfo"].data.crops.Freeform = collections[i].crop.crops.Freeform;
          }
        }
        ContentService.updateContent(image);
      }
    });
  };

  $scope.updateCollection = function() {
    $scope.saving = true;

    var updateAspectPromises = $scope.entries.map(function(entry) {
      return $scope.addMissingCollectionAspect(entry);
    });
    $q.all(updateAspectPromises).then(function() {
      var updateEntryPromises = $scope.entries.map(function(entry) {
        return $scope.updateEntry(entry);
      });

      $q.all(updateEntryPromises).then(function() {
        var skipContents = !hasDeskGalleryWidget;
        return CollectionService.updateCollection($scope.collection, $scope.entries, skipContents).then(function (response) {
          updateScopeCollection(response);
          if (configuration.getBroadcastCropFromCollectionToImage() !== undefined && configuration.getBroadcastCropFromCollectionToImage().length > 0){
            var arrayLength = $scope.entries.length;
            for (var i = 0; i < arrayLength; i++) {
              broadcastCropFromCollectionToImage($scope.entries[i].id, configuration.getBroadcastCropFromCollectionToImage());
            }
          }
          $rootScope.currentEditingCollection = $scope.collection;
          $scope.lastSavedEntries = $scope.entries.slice(0);
          $rootScope.$broadcast("dam:collectionUpdated", $scope.collection.id);
          setDirty(false);
          $scope.aligned = false;

          DamNotificationService.addNotification(atex.dam.Notification({type: 'success', message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__}), false);
          purgeHandledLinks().finally(function () {
            $scope.saving = false;
          });
        }).then(null, function (error) {
          $scope.saving = false;
          var message = $translate.getTranslationTable().__ERROR_DURING_COLLECTION_UPDATE__;
          if (error && error.cause) {
            message = error.cause;
          }
          DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
        });
      });
    });
  };

  $scope.updateEntry = function(entry) {
    if(entry.data.aspects['atex.collection']) {
      entry.data.aspects['atex.collection'].data._type='com.atex.onecms.app.dam.collection.aspect.CollectionAspect';
      entry.data.aspects['atex.collection'].data.collections.forEach(function(collection) {
        collection._type='com.atex.onecms.app.dam.collection.aspect.Collection';
        collection.field._type='com.atex.onecms.app.dam.collection.aspect.Field';
      });

      return DamService.updateEntryCollectionMetadata(entry.data.aspects['atex.collection']).then(function(response) {});
    } else {
      return $q.when();
    }
  };

  $scope.addMissingCollectionAspect = function(entry) {
    return ContentService.getContent({id: entry.id}).then(function (image) {
      if (!image.data.aspects["atex.collection"]){
        var aspect = {};
        aspect._type = 'atex.collection';
        image.data.aspects["atex.collection"] = {};
        image.data.aspects["atex.collection"].data = {};
        aspect.contentId = image.id;
        aspect.collections = [];
        var collection = {};
        collection.contentId = $scope.collection.id;
        collection.field = {};
        collection.field.description = image.data.aspects.contentData.data.description;
        collection.field.headline = image.data.aspects.contentData.data.headline;
        collection.field.caption = image.data.aspects.contentData.data.caption;
        collection.field.organization = image.data.aspects.contentData.data.organization;
        collection.field.byline = image.data.aspects.contentData.data.byline;
        aspect.collections.push(collection);
        image.data.aspects["atex.collection"].data  = aspect;
        var transferInfo = {
          id: image.id,
          data: image.data,
          revision: image.revision
        };
        return ContentService.updateContent(transferInfo).then(function (response) {
          return response;
        });
      }else{
        return $q.when();
      }
    });
  };

  $scope.initCallback = function() {
    // console.log("INFO: Current Template id: " + $scope.template.id);
    var check = false;
    if ($scope.template.type) {
      check = valdrUtil.has(valdrProvider.getConstraints(), $scope.template.type);
    }
    return check;
  };

  $scope.$on(valdrEvents.validated, function(event) {
    if (!$scope.myForm.$valid) {
      $scope.valdError = atex.dam.ViewUtils.checkViewStateArray($scope.viewsStateArray, event);
    } else {
      $scope.valdError = false;
    }
  });

  $scope.editCallback = function() {};

  $scope.hideSpinner = function() {
    $scope.showSpinner = false;
    $timeout(function() {
      $rootScope.$broadcast("dam:templatedViewReady");
    });
  };

  $scope.changeStartCallback = function() {};

  $scope.changeEndCallback = function(data) {
    if ($scope.readonly) {
      return;
    }
    var oldDefaultFormat = atex.onecms.ObjectUtils.getByPath($scope.collection.data, 'aspects/contentData/data/defaultCrop');
    var newDefaultFormat = atex.onecms.ObjectUtils.getByPath(data, 'aspects/contentData/data/defaultCrop');
    $scope.collection.data = data;
    if (oldDefaultFormat !== newDefaultFormat) {
      $timeout(function(){
        $rootScope.$broadcast("dam:checkTumbCrop");
      });
    }
    setDirty(true);
    $scope.$digest();
  };

  $scope.edit = function() {
    if ($scope.readonly) {
      $state.go('list.collection', { 'id' : $scope.id, 'preview': null });
      return;
    }
    var _ids = [];
    $scope.selected.forEach(function(item) {
      _ids.push(item);
    });
    isEditingChilds = true;
    $state.go('list.edit', { ids : _ids });
  };

  $scope.$on("dam:collectionDeleted", function(event, collection) {});

  $scope.$on("dam:collectionUpdated", function(event, collectionId) {
    if (!$scope.saving && $scope.id === collectionId) {
      $state.go($state.current, {}, {reload: true});
    }
  });

  // Setup onBeforeUnload to prompt for unsaved changes
  var onBeforeUnloadFn = function() {
    if (CollectionService.getDirty()) {
      // Return a msg just as a reminder but the browsers are now using always a default msg [max]
      // See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload
      return "Do you want to leave this site?\nChanges you made may not be saved.";
    }
  };
  $window.onbeforeunload = onBeforeUnloadFn;
  $scope.$on('$destroy', function() {
    $window.onbeforeunload = undefined;
  });

  // Check for new available resources
  $scope.newAvailableResources = [];
  var checkChangesOnSrvInterval = 2000;
  var mapResourceIdVsLink = {};
  var handledLinks = []; // keep track of the already loaded links

  function checkIfItemIsInArray(array, item) {
    if (!array || !angular.isArray(array)) {
      return false;
    }
    var exists = false;
    array.forEach(function(_item) {
      if (_item === item) {
        exists = true;
      }
    });
    return exists;
  }

  function loadCollectionLinks(collectionId) {
    var transferInfo = {};
    transferInfo['fl'] = 'id, version, resource_atex_desk_ss';
    transferInfo['core'] = 'onecms';
    transferInfo['q'] = '+type_atex_desk_ss:(CollectionLink)';
    transferInfo['sort'] = 'modificationTime asc';
    var splits = collectionId.split(':');
    if (splits.length!==2) {
      return $q.reject();
    }
    transferInfo['q'] += '+collection_atex_desk_ss:(' + splits[0] +"\\:" + splits[1] + ')';
    return SearchService.search(transferInfo).then(function(response) {
      var newIds = [];
      response.data.response.docs.forEach(function(item) {
        newIds.push(item.resource_atex_desk_ss);
        // If it's a new Link set deleted = false, otherwise keep the old deleted value
        mapResourceIdVsLink[item.resource_atex_desk_ss] = {
          'id': item.id,
          'revision': "\"" + item.version + "\"",
          'deleted': mapResourceIdVsLink[item.resource_atex_desk_ss] && mapResourceIdVsLink[item.resource_atex_desk_ss].deleted
        };
      });
      return newIds;
    });
  }

  function loadAvailableNewResources() {
    // Load CollectionLinks and check if there are some links not yet handled
    // And in case populate the $scope.newAvailableResources
    $scope.newAvailableResources = [];
    return loadCollectionLinks($scope.collection.id).then(function(newResources) {
      newResources.forEach(function(resource) {
        var completeResourceId = atex.dam.AngularUtils.addPrefix(resource);
        if (!checkIfItemIsInArray($scope.collection.data.aspects.contentData.data.contents, completeResourceId)) {
          if (!checkIfItemIsInArray(handledLinks, completeResourceId)) {
            $scope.newAvailableResources.push(completeResourceId);
          }
        }
      });
    });
  }

  function watch4NewCollectionLinks() {
    var checkNewLinks = function () {
      if (!$scope.collection.id) {
        return;
      }
      if ($scope.saving || $scope.newAvailableResources.length>0) {
        $timeout(function () {
          checkNewLinks();
        }, checkChangesOnSrvInterval, false);
        return;
      }
      // console.log("Checking New Suggested Resources...");
      loadAvailableNewResources().finally(function(){
        $timeout(function () {
          checkNewLinks();
        }, checkChangesOnSrvInterval, false);
      });
    };
    checkNewLinks();
  }

  function purgeHandledLinks() {
    var deletePromises = [];
    handledLinks.forEach(function(item){
      var onlyId = atex.dam.AngularUtils.removePrefix(item);
      if (mapResourceIdVsLink[onlyId] && !mapResourceIdVsLink[onlyId].deleted) {
        deletePromises.push(ContentService.deleteContent({
          id: mapResourceIdVsLink[onlyId].id,
          revision: mapResourceIdVsLink[onlyId].revision
        }).then(function () {
          mapResourceIdVsLink[onlyId].deleted = true;
        }));
      }
    });
    return $q.all(deletePromises);
  }

  $scope.loadNewResources = function() {
    $scope.saving = true;
    var dirty = false;
    return loadAvailableNewResources().then(function(){
      var itemsToAddPromises = [];
      $scope.newAvailableResources.forEach(function(newItem) {
        handledLinks.push(newItem);
        $scope.collection.data.aspects.contentData.data.contents.push(newItem);
        itemsToAddPromises.push(ContentService.getContent({id: atex.dam.AngularUtils.removePrefix(newItem)}));
      });
      return $q.all(itemsToAddPromises).then(function(newItems) {
        newItems.forEach(function(newItem) {
          newItem._data = newItem.data;
          newItem._data.id = newItem.id;
          newItem.contentId = newItem.id;
          atex.dam.AngularUtils.fixUrls(newItem._data);
          atex.dam.AngularUtils.fixWidthHeight(newItem, 120);
          $scope.entries.push(newItem);
          dirty = true;
        });
        $scope.newAvailableResources = [];
        $scope.saving = false;
        if (dirty) {
          setDirty(dirty);
        }
      });
    });
  };

  $scope.isPublished = function() {
    var engagementAspect = atex.onecms.ObjectUtils.getByPath($scope.collection, 'data/aspects/engagementAspect/data');
    if (engagementAspect){
      $scope.appPk = engagementAspect.engagementList[0].appPk;
      $scope.appType = engagementAspect.engagementList[0].appType;
      return engagementAspect.engagementList[0].appPk.startsWith("policy:") || engagementAspect.engagementList[0].appPk.startsWith("ace:");
    }else{
      return false;
    }
  };

  $scope.copyPublicationLink = function() {
    //if ($scope.appPk.startsWith("ace:") || !($scope.collection && $scope.collection.data.aspects.contentData.data.objectType.toLowerCase().includes("collection"))){
      getPublicationUrl().then(function(url) {
        textToClipboard(url);
        notifySuccess();
      }, function(error) {
        notifyError(error);
      });
    /*}else if ($scope.appPk.startsWith("policy:")){
      $scope.previewPolicyEntry($scope.appType, $scope.appPk, false);
    }*/
  };

  $scope.openPublicationLink = function() {
    //if ($scope.appPk.startsWith("ace:") || !($scope.collection && $scope.collection.data.aspects.contentData.data.objectType.toLowerCase().includes("collection"))){
      getPublicationUrl().then(function(url) {
        $window.open(url, '_blank');
      }, function(error) {
        notifyError(error);
      });
    /*}else if ($scope.appPk.startsWith("policy:")){
      $scope.previewPolicyEntry($scope.appType, $scope.appPk, true);
    }*/
  };

  $scope.previewPolicyEntry = function(appType, value, openPage) {
    var contentId = atex.dam.AngularUtils.removePolicyPrefix(value);
    DamService.getGalleryUrl(contentId).then(function(galleryUrl) {
      var url = galleryUrl.data+"#device=window&width=840";
      if (openPage){
        $window.open(url, "_blank");
      }else{
        textToClipboard(url);
        notifySuccess();
      }
    });
  };

  function textToClipboard (text) {
    var dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
  }

  function getPublicationUrl() {
    var deferred = $q.defer();

    AuthenticationService.getCurrentUser().then(function (currentUser) {
      $window.atex.analytics('event', {e: "get-remote-publication-url", d1: $scope.collection.id});
      var url = "/onecms/dam/content/publicationUrl/contentid/" + $scope.collection.id;
      $http({
        method: 'GET',
        url: url,
        headers: {
          'Content-Type': 'text/plain',
          'X-Auth-Token': currentUser.token
        }
      }).then(function (response) {
        deferred.resolve(response.data.url);
      }, function (error) {
        deferred.reject(error);
      });
    });
    return deferred.promise;
  }

  function notifySuccess() {
    DamNotificationService.addNotification(atex.dam.Notification({
      type: 'success',
      message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
    }), false);
  }

  function notifyError(error) {
    DamNotificationService.addNotification(atex.dam.Notification({
      type: 'error',
      message: $translate.getTranslationTable().__GUI_CLIPBOARD_ERROR__ + error.statusText
    }), true);
  }

  $scope.$on("dam:collectionEntryRemove", function(event, resourceId) {
    var dirty = false;
    var completeResourceId = atex.dam.AngularUtils.addPrefix(resourceId);
    var i = $scope.collection.data.aspects.contentData.data.contents.length;
    while (i--) {
      if ($scope.collection.data.aspects.contentData.data.contents[i]===completeResourceId) {
        $scope.collection.data.aspects.contentData.data.contents.splice(i, 1);
        dirty = true;
        // Remove from $scope.entries
        var j = $scope.entries.length;
        while(j--) {
          if ($scope.entries[j].id===resourceId) {
            $scope.entries.splice(j, 1);
            dirty = true;
          }
        }
      }
    }
    if (dirty) {
      setDirty(dirty);
    }
  });

}]);

